//user列表查询的表头
export const USER_LIST_COLUMNS = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号'
    },
    {
        title: '账号',
        en_title: 'Account No.',
        ch_title: '账号',
        dataIndex: '账号',
        sorter: (a, b) => a['账号'].localeCompare(b['账号']),
    },
    {
        title: '名称',
        en_title: 'Username',
        ch_title: '名称',
        dataIndex: '名称'
    },
    {
        title: '职称',
        en_title: 'Job Title',
        ch_title: '职称',
        dataIndex: '职称'
    },
    {
        title: '状态',
        en_title: 'Status',
        ch_title: '状态',
        dataIndex: '状态'
    },
];

//用户列表查询
export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";
//更新用户
export const USER_UPDATE_REQUEST = "USER_UPDATE_STATUS_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_STATUS_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_STATUS_FAIL";